import $ from 'jquery';
import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  ElementRef,
  Output,
  EventEmitter,
  Input,
  ChangeDetectorRef,
  ViewChild,
} from '@angular/core';
import { GeneralUpgradeComponent } from './general-upgrade.component';
import { FeatureUpgradeComponent } from './feature-upgrade.component';
import { DevicesUpgradeComponent } from './devices-upsell.component';

import { FeatureUpgradeService } from './upgrade.service';
import { pushUpsellViewGTMEvent, UPSELL_COMPONENT_EVENT_NAME } from '@lib/gtm-events';

import { isValidUpsellFeatureKey, upsellEventId } from './upsell-config';

@Component({
  selector: 'general-upgrade-modal',
  templateUrl: './general-upgrade-modal.component.html',
  styleUrls: [ '../../styles/upgrade.scss', './general-upgrade-modal.component.scss'],
})

export class GeneralUpgradeModalComponent implements OnInit {
  @ViewChild('generalUpgradeViewChild', { static: false }) public generalUpgradeViewChild: GeneralUpgradeComponent;
  @ViewChild('featureUpgradeViewChild', { static: false }) public featureUpgradeViewChild: FeatureUpgradeComponent;
  @ViewChild('devicesUpgradeViewChild', { static: false }) public devicesUpgradeViewChild: DevicesUpgradeComponent;

  @Input() public featureKeyName: string;
  @Input() public componentName: string;
  @Input() public getQuoteProductInterestKey: string;
  @Output() public isModalOpen: EventEmitter<boolean> = new EventEmitter();
  public el: HTMLElement;
  public $modal: any;

  constructor(elRef: ElementRef, private cdr: ChangeDetectorRef, private featureUpgradeService: FeatureUpgradeService) {
    this.el = elRef.nativeElement;
  }

  public ngOnInit(): void {
    this.$modal = $(this.el.querySelector('.ui.modal'));
    this.$modal.modal({
      closeable: true,
      dimmerSettings: {
        closable: true,
      },
      onShow: () => {
        this.isModalOpen.emit(true);
        if (isValidUpsellFeatureKey(this.featureKeyName)) {
          pushUpsellViewGTMEvent(
            UPSELL_COMPONENT_EVENT_NAME[this.componentName],
            upsellEventId(this.$modal, this.featureKeyName),
          );
        }
      },
      onHide: () => {
        if (this.generalUpgradeViewChild) {
          this.featureUpgradeService.emitFeatureModalHiddenEvent();
        }

        if (this.featureUpgradeViewChild) {
          this.featureUpgradeService.emitFeatureModalHiddenEvent();
        }

        if (this.devicesUpgradeViewChild) {
          this.featureUpgradeService.emitFeatureModalHiddenEvent();
        }
        this.cdr.detectChanges();
      },
    });
  }

  public show(e: Event): void {
    this.$modal.modal('show');

    if (e) {
      e.stopPropagation();
    }
  }

  public hide(e: Event): void {
    this.$modal.modal('hide');

    if (e) {
      e.stopPropagation();
    }
  }
}
